<ngx-datatable    
    #tableAtivo    
    class="material"
    [columnMode]="ColumnMode.force"
    [headerHeight]="50"
    [footerHeight]="50"
    [rowHeight]="'auto'"
    [scrollbarH]="true"
    [rows]="rows"
    [rowClass]="getRowClass"
>

    <ngx-datatable-column 
        name="Data" 
        prop="data_compra"
        [sortable]="false"
        [width]="100"
        [frozenLeft]="true"
    >
        <ng-template 
            let-rowIndex="rowIndex" 
            let-row="row" 
            ngx-datatable-cell-template
        >
            {{row.data_inicio | date:'dd/MM/yy'}}
        </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column 
        name="Ativo" 
        prop="ativo"
        [sortable]="false"
        [frozenLeft]="true"
    >
        <ng-template 
            let-rowIndex="rowIndex" 
            let-row="row" 
            ngx-datatable-cell-template
        >
        <span>{{row.ativo.sigla}}</span>
        </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column 
        name="Qtd. Clientes Enviados" 
        prop="rv_clientes_qtd_enviados"
        [sortable]="false"
        *ngIf="this.user.role_id == 7 || this.user.role_id == 2 || this.user.tipo_usuario_id == 2"
    >
        <ng-template 
            let-rowIndex="rowIndex" 
            let-row="row" 
            ngx-datatable-cell-template
        >
        <span>{{row.rv_clientes_qtd_enviados | number : '1.0-0'}}</span>        
        </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column 
        name="Qtd. Clientes Efetivados" 
        prop="rv_clientes_qtd_efetivados"
        [sortable]="false"
        *ngIf="this.user.role_id == 7 || this.user.role_id == 2 || this.user.tipo_usuario_id == 2"
    >
        <ng-template 
            let-rowIndex="rowIndex" 
            let-row="row" 
            ngx-datatable-cell-template
        >
        <span>{{row.rv_clientes_qtd_efetivados | number : '1.0-0'}}</span>        
        </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column 
        name="%" 
        prop="rv_clientes_qtd_efetivados"
        [sortable]="false"
        *ngIf="this.user.role_id == 7 || this.user.role_id == 2 || this.user.tipo_usuario_id == 2"
        [width]="100"
    >
        <ng-template 
            let-rowIndex="rowIndex" 
            let-row="row" 
            ngx-datatable-cell-template
        >
            <span>
                {{
                    row.rv_clientes_qtd_efetivados > 0 && row.rv_clientes_qtd_enviados > 0 ?
                    ( (row.rv_clientes_qtd_efetivados / row.rv_clientes_qtd_enviados) * 100 | number : '1.2-2') + ' %' :
                    '0,00 %'
                }}   
            </span>        
        </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column 
        name="Vol. Enviada (R$)" 
        prop="rv_volume_enviado"
        [sortable]="false"
        *ngIf="this.user.role_id == 7 || this.user.role_id == 2 || this.user.tipo_usuario_id == 2"
        [width]="150"
    >
        <ng-template 
            let-rowIndex="rowIndex" 
            let-row="row" 
            ngx-datatable-cell-template
        >
        <span>{{ row.rv_volume_enviado > 0 ? ('R$ ' + (row.rv_volume_enviado | number : '1.2-2') ) : 'R% 0,00'}}</span>        
        </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column 
        name="Vol. Efetivado (R$)" 
        prop="rv_volume_efetivado"
        [sortable]="false"
        *ngIf="this.user.role_id == 7 || this.user.role_id == 2 || this.user.tipo_usuario_id == 2"
    >
        <ng-template 
            let-rowIndex="rowIndex" 
            let-row="row" 
            ngx-datatable-cell-template
        >
            <span>
                {{
                    row.rv_volume_efetivado > 0 ? 
                    ('R$ ' + (row.rv_volume_efetivado | number : '1.2-2') ) : 
                    'R% 0,00'
                }}
            </span>
        </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column 
        name="%" 
        prop="rv_percent_vol_clients"
        [sortable]="false"
        *ngIf="this.user.role_id == 7 || this.user.role_id == 2 || this.user.tipo_usuario_id == 2"
        [width]="100"
    >
        <ng-template 
            let-rowIndex="rowIndex" 
            let-row="row" 
            ngx-datatable-cell-template
        >
        <span>
            {{
                row.rv_volume_efetivado > 0 && row.rv_volume_enviado > 0 ?
                ( (row.rv_volume_efetivado / row.rv_volume_enviado) * 100 | number : '1.2-2') + ' %' :
                '0,00 %'
            }}            
        </span>        
        </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column 
        name="P. Compra" 
        prop="ativo_preco_compra"
        [sortable]="false"
    >
        <ng-template 
            let-rowIndex="rowIndex" 
            let-row="row" 
            ngx-datatable-cell-template
        >
        <span>R$ {{row.ativo_preco_compra | number : '1.2-2'}}</span>
        </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column 
        name="P. Hoje" 
        prop="ativo"
        [sortable]="false"
    >
        <ng-template 
            let-rowIndex="rowIndex" 
            let-row="row" 
            ngx-datatable-cell-template
        >
        <span>R$ {{row.ativo.cotacao_atual | number : '1.2-2'}}</span>
        </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column 
        name="Volatidade %" 
        prop="rv_volatilidade"
        [sortable]="false"
    >
        <ng-template 
            let-rowIndex="rowIndex" 
            let-row="row" 
            ngx-datatable-cell-template
        >
        <span>{{ row.rv_volatilidade | number : '1.2-2' }} %</span>
        </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column 
        name="P. Alvo Corretora" 
        prop="ativo_preco_alvo_corretora"
        [sortable]="false"
    >
        <ng-template 
            let-rowIndex="rowIndex" 
            let-row="row" 
            ngx-datatable-cell-template
        >
        <span>R$ {{ row.ativo_preco_alvo_corretora | number : '1.2-2' }}</span>
        </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column 
        name="P. Venda Escritório" 
        prop="ativo_preco_alvo_escritorio"
        [sortable]="false"
    >
        <ng-template 
            let-rowIndex="rowIndex" 
            let-row="row" 
            ngx-datatable-cell-template
        >
        <span>R$ {{ row.ativo_preco_alvo_escritorio | number : '1.2-2' }}</span>
        </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column 
        name="Proteção" 
        prop="valor_protecao"
        [sortable]="false"
    >
        <ng-template 
            let-rowIndex="rowIndex" 
            let-row="row" 
            ngx-datatable-cell-template
        >
            <span>
                {{ 
                    row.valor_protecao != 0 && row.valor_protecao != null ?  
                    ( (row.valor_protecao | number : '1.2-2') + ' %' ) : 
                    '0,00 %' 
                }}
            </span>
        </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column 
        name="Proventos" 
        prop="valor_proventos"
        [sortable]="false"
    >
        <ng-template 
            let-rowIndex="rowIndex" 
            let-row="row" 
            ngx-datatable-cell-template
        >
            <span>
                {{ 
                    row.valor_proventos != 0 && row.valor_proventos != null ?  
                    ( (row.valor_proventos | number : '1.2-2') + ' %' ) : 
                    '0,00 %' 
                }}
            </span>
        </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column 
        name="Prêmios" 
        prop="valor_premio"
        [sortable]="false"
    >
        <ng-template 
            let-rowIndex="rowIndex" 
            let-row="row" 
            ngx-datatable-cell-template
        >
            <span>
                {{ 
                    row.valor_premio != 0 && row.valor_premio != null ?  
                    ( (row.valor_premio | number : '1.2-2') + ' %' ) : 
                    '0,00 %' 
                }}                
            </span>
        </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column 
        name="Data Saída" 
        prop="data_fim"
        [sortable]="false"
        [width]="100"
    >
        <ng-template 
            let-rowIndex="rowIndex" 
            let-row="row" 
            ngx-datatable-cell-template
        >
            {{row.data_fim | date:'dd/MM/yy'}}
        </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column 
        name="Qtd Dias" 
        prop="qtd_dias_trade" 
        [sortable]="false"                                
    >
        <ng-template 
            let-rowIndex="rowIndex" 
            let-row="row" 
            ngx-datatable-cell-template
        >
            {{ row.qtd_dias_trade | number : '1.0-0' }}
        </ng-template>
    </ngx-datatable-column>   
    
    <ngx-datatable-column 
        name="Peformance" 
        prop="valor_perfomance"
        [sortable]="false"
    >
        <ng-template 
            let-rowIndex="rowIndex" 
            let-row="row" 
            ngx-datatable-cell-template
        >
            <span>
                {{ 
                    row.valor_perfomance != 0 && row.valor_perfomance != null ?  
                    ( (row.valor_perfomance | number : '1.2-2') + ' %' ) : 
                    '0,00 %' 
                }}                 
            </span>
        </ng-template>
    </ngx-datatable-column>


    <ngx-datatable-column 
        name="Ações" 
        prop="id" 
        [sortable]="false" 
        *ngIf="this.user.role_id == 7 || this.user.role_id == 2 || this.user.tipo_usuario_id == 2"
    >
        
        <ng-template 
            let-rowIndex="rowIndex" 
            let-row="row" 
            ngx-datatable-cell-template
        >            
            <span>
                <button 
                    mat-icon-button 
                    matTooltip="Alterar" 
                    (click)="openChange(row.id)"
                >
                    <mat-icon aria-label="Editar">edit</mat-icon>
                </button>

                <button 
                    mat-icon-button 
                    color="warn" 
                    matTooltip="Excluir" 
                    (click)="delete(row.id)"
                >
                    <mat-icon aria-label="Excluir ativo da carteira">delete</mat-icon>
                </button>
            </span>            
        </ng-template>
    </ngx-datatable-column>
</ngx-datatable>